/*
* This module is in charge of handling clicks in clear filter button of no result page experience.
*/
import { store } from '@redux/store';
import { searchParametersActions } from 'features/searchResultsFacets';

/**
 * clearFilters: dispatches a clearFilters action in the searchParametersActions.
 */
const clearFilters = (event) => {
  if (!event.target || !Object.prototype.hasOwnProperty.call(event.target.dataset, 'noResultsClearButton')) {
    return;
  }

  event.preventDefault();
  store.dispatch(searchParametersActions.clearFilters());
}

document.addEventListener('click', clearFilters);